import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const UsersXIcon = ({ sx, ...props }: SvgIconProps) => {
    return (
        <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M13.7501 13.3333L17.9167 17.5M17.9167 13.3333L13.7501 17.5M12.9167 2.7423C14.1383 3.23679 15.0001 4.43443 15.0001 5.83333C15.0001 7.23224 14.1383 8.42988 12.9167 8.92437M10.0001 12.5H6.66675C5.11361 12.5 4.33704 12.5 3.72447 12.7537C2.90771 13.092 2.2588 13.741 1.92048 14.5577C1.66675 15.1703 1.66675 15.9469 1.66675 17.5M11.2501 5.83333C11.2501 7.67428 9.7577 9.16667 7.91675 9.16667C6.0758 9.16667 4.58341 7.67428 4.58341 5.83333C4.58341 3.99238 6.0758 2.5 7.91675 2.5C9.7577 2.5 11.2501 3.99238 11.2501 5.83333Z"
                stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill={"none"}/>
        </SvgIcon>

    );
};

export default UsersXIcon;
